import React, {useState, useEffect} from "react";
import {
    Box,
    Text,
    Textarea,
    Button,
    useColorModeValue,
    useToast,
    Flex,
    FormControl,
    Tooltip,
    Select,
    Spinner,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Menu,
    MenuButton,
    IconButton,
    MenuList,
    MenuItem,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter
} from "@chakra-ui/react";
import {cqAPI} from "../../lib/Auth";
import {EditIcon} from "@chakra-ui/icons";
import CustomizeAIAssistantHeader from "./CustomizeAIAssistantHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsisV} from "@fortawesome/free-solid-svg-icons";
import CustomizeAIDetail from "./CustomizeAIDetail";
import moment from "moment/moment";
import {useNavigate} from "react-router-dom";
import CustomizeAIAssistantInstruction from "./CustomizeAIAssistantInstruction";
import { STORAGE_KEY } from "./CustomizeAIAssistant";

const CustomizeAI = () => {
    const bgColor = useColorModeValue("gray.100", "gray.700");
    const [instructions, setInstructions] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [organizedInstructions, setOrganizedInstructions] = useState({});
    const [updatedAt, setUpdatedAt] = useState("");
    const [bid, setBid] = useState("");
    const [vavGreeting, setVavGreeting] = useState('');
    const [selectedVoice, setSelectedVoice] = useState("Linda");
    const [defaultGreeting, setDefaultGreeting] = useState('');
    const [isGreetingEditing, setIsGreetingEditing] = useState(false);
    const [isVavEnable, setIsVavEnable] = useState(false);
    const [isSavingGreeting, setIsSavingGreeting] = useState(false);
    const [defaultGreetingStart, setDefaultGreetingStart] = useState('');
    const bgBoxColor = useColorModeValue("#ffffff", '#212330');
    const tabColor = useColorModeValue("blackAlpha", 'whiteAlpha');
    const {isOpen, onOpen, onClose} = useDisclosure()
    const toast = useToast();
    const navigate = useNavigate();

  const [instructionsDraft, setInstructionsDraft] = useState(() => {
    try {
      const draft = localStorage.getItem(STORAGE_KEY);
      return draft ? JSON.parse(draft) : "";
    } catch {
      return "";
    }
  });


  const fetchAiSettings = async () => {
    try {
      const response = await cqAPI.get("/settings/ai");
      if (response.type === "ok") {
        setDefaultGreetingStart(response?.data?.vav?.start || '');
        setDefaultGreeting(response?.data?.vav?.default_value || '');
        setOrganizedInstructions(response?.data?.organized_instructions || {});
        setInstructions(response?.data?.instructions || "");
        setSelectedVoice(response?.data?.vav?.english_voice_name || "Linda");
        setUpdatedAt(response?.data?.updated || "");
        setBid(response?.data?.bid);
        console.log(response?.data?.bid)
        if (response.data?.vav?.greeting) {
          setVavGreeting(response?.data?.vav?.greeting);
        } else {
          setVavGreeting(response?.data?.vav?.default_value || '')
        }
        setIsVavEnable(response.data.vav.enabled);
      }
      console.log(vavGreeting)
    } catch (error) {
      console.error("Error loading voice auto pilot greeting:", error);
      toast({
        title: "Error",
        description: "Failed to load voice auto pilot greeting.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
    useEffect(() => {
        fetchAiSettings();
    }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(instructionsDraft));
    } catch {
      console.error("Failed to save Drafts.");
    }
  }, [instructionsDraft]);

    useEffect(() => {
        const draft = localStorage.getItem(STORAGE_KEY);
        draft && setInstructionsDraft(JSON.parse(draft));
    }, [])

    const handleSaveGreeting = async () => {
        try {
            setIsSavingGreeting(true);
            const response = await cqAPI.post("/settings/ai", {
                greeting: vavGreeting,
                english_voice_name: selectedVoice,
            });

            if (response.type === "ok") {
                toast({
                    title: response.msg || "Saved successfully.",
                    description: "Your voice auto pilot greeting have been saved.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                setIsGreetingEditing(false);
            } else {
                toast({
                    title: "Error",
                    description: response.msg || 'Failed to save!',
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: error.msg,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
        setIsSavingGreeting(false);
    };

    const handleVoiceChange = (value) => setSelectedVoice(value);

    const handleGreetingChange = async (value) => {
        setVavGreeting(value)
    }

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const res = await cqAPI.post("/settings/ai", {
        instructions: instructionsDraft,
      });
      if (res.type === "ok") {
        toast({
          title: "Updated!",
          description: "AI settings updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setIsEditing(false)
        setIsSubmitting(false);
        setInstructionsDraft("");
        fetchAiSettings();
      } else {
        toast({
          title: "Error",
          description: res.msg || "Failed to save.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (e) {
      setIsSubmitting(false);
      toast({
        title: "Error",
        description: e?.msg || "Unexpected error while configuring.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

    return (
      <Box m={4} px={4} width="100%" height="100%" overflowY="auto" backgroundColor={bgBoxColor} borderRadius="8px">
        <Tabs isFitted variant='line' width='full' colorScheme={tabColor} isLazy>
          <TabList width="75%">
            <Tab>Set Up AI</Tab>
            <Tab>Voice Auto Pilot Setup</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              {/*<CustomizeAIAssistantHeader draft={instructionsDraft}/>*/}
              <Box mt={4} p={1} bgColor={bgColor} borderRadius="md" width="full">
                <Flex align="center" minH="90px" flexDirection="column" alignItems="start">
                  <Flex flexDirection="row" alignItems="center" width="100%">
                    <Flex justifyContent="flex-start" flexDirection="column" mt={2} alignItems='start'>
                      <Text fontSize="sm" fontWeight="bold" ml={2}>
                        AI Settings
                      </Text>
                      {updatedAt &&
                        <Text fontSize="sm" ml={2} mt={1}>
                          Updated: {moment(updatedAt).format("MMMM D, YYYY h:mm a")}
                        </Text>
                      }
                    </Flex>
                    <Flex justifyContent="flex-end" ml='auto' gap={2} my={1} mr={2} minHeight="40px"
                          alignItems="center">
                      {isEditing && (
                        <>
                          <Button
                            isDisabled={!isEditing || isSubmitting}
                            size="sm"
                            onClick={() => {
                              setIsEditing(false)
                              setInstructionsDraft("")
                            }}>Cancel</Button>
                          <Button
                            isDisabled={!isEditing || isSubmitting}
                            size="sm"
                            onClick={handleSubmit}> {isSubmitting ?
                            <Spinner/> : "Save"}
                          </Button>
                        </>)}
                      <Menu flexBasis="5%">
                        <MenuButton as={IconButton} aria-label="Options"
                                    icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                                    variant="ellipsis"/>
                        <MenuList>
                          {!isEditing &&
                            <MenuItem onClick={() => setIsEditing(true)}>
                              Edit
                            </MenuItem>
                          }
                          <MenuItem
                            onClick={() => navigate(`/settings/customize-ai/history?bid=${bid}`)}>
                            Setup History
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </Flex>
                  </Flex>
                  <Flex minH="90px" flexDirection="column" gap={2} width="100%">
                    <Flex flexDirection="column" align="start" m={4}>
                      <Textarea
                        value={isEditing ? instructionsDraft || instructions : instructions}
                        isDisabled={!isEditing || isSubmitting}
                        height="400px"
                        onChange={(e) => {
                          setInstructionsDraft(e.target.value)
                        }}/>
                    </Flex>
                  </Flex>
                </Flex>
              </Box>
              <Box mt={4} p={1} bgColor={bgColor} borderRadius="md" width="full">
                <Flex align="center" minH="90px" flexDirection="column" alignItems="start">
                  <Flex flexDirection="row" alignItems="center" width="100%">
                    <Flex justifyContent="flex-start" flexDirection="column" mt={2} alignItems='start'>
                      <Text fontSize="sm" fontWeight="bold" ml={2}>
                        AI Details
                      </Text>
                    </Flex>
                      <Flex justifyContent="flex-end" ml='auto' gap={2} my={1} mr={2} minHeight="40px"
                          alignItems="center">

                      <Menu flexBasis="5%">
                        <MenuButton as={IconButton} aria-label="Options"
                                    icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                                    variant="ellipsis"/>
                        <MenuList>
                          {instructions && <MenuItem onClick={onOpen}>
                            Edit
                          </MenuItem>}
                        </MenuList>
                      </Menu>
                    </Flex>
                  </Flex>
                  <CustomizeAIDetail organized_instructions={organizedInstructions}/>
                </Flex>
              </Box>
            </TabPanel>
            <TabPanel>
              <Box p={1} bgColor={bgColor} borderRadius="md" width="full">
                <Flex align="center" minH="200px" flexDirection="column" alignItems="start">
                  <Flex flexDirection="row" alignItems="center" width="100%">
                    <Flex justifyContent="flex-start">
                      <Text fontSize="sm" fontWeight="bold" mb={2} ml={2}>
                        Voice Auto Pilot Greeting:
                      </Text>
                    </Flex>
                    <Flex justifyContent="flex-end" ml='auto' gap={2} mb={2} minHeight="40px"
                          alignItems="center">
                      {isVavEnable && isGreetingEditing ? (
                          <>
                            <Button id={"reset-greeting"}
                                    onClick={() => setVavGreeting(defaultGreeting)}
                                    size="sm" variant="ghost" mr={3} mt={1}>Reset to
                              Default</Button>
                            <Button isDisabled={isSavingGreeting} size="sm" id={"cancel-greeting"}
                                    onClick={() => setIsGreetingEditing(false)}>cancel</Button>
                            <Button isDisabled={isSavingGreeting} size="sm" id={"save-greeting"}
                                    onClick={handleSaveGreeting}> {isSavingGreeting ?
                              <Spinner/> : "Save"}
                            </Button>
                          </>)
                        :
                        isVavEnable && (
                          <EditIcon id={"edit-greeting"} mr={1}
                                    onClick={() => isVavEnable && setIsGreetingEditing(true)}/>)
                      }
                    </Flex>
                  </Flex>
                  {/* Greeting textarea */}
                  <Tooltip
                    label={isVavEnable ? "Select edit to make changes" : "You need to enable autopilot feature."}
                    aria-label="A tooltip"
                    isDisabled={isGreetingEditing}
                    placement="top-end"
                    mr={6}
                  >
                    <Textarea
                      isDisabled={!isGreetingEditing}
                      placeholder="Enter your voice auto pilot greeting here..."
                      id="vav_greeting"
                      minH="120px"
                      value={vavGreeting}
                      onChange={(e) => handleGreetingChange(e.target.value)}
                    />
                  </Tooltip>
                  {/* Voice selector */}
                  <Box mt={6} width="100%">
                    <Flex justifyContent="flex-start">
                      <Text fontSize="sm" fontWeight="bold" mb={2} ml={2}>
                        Auto Pilot Voice:
                      </Text>
                    </Flex>
                    <FormControl mt={4} width="100%" isDisabled={!isGreetingEditing}>
                      <Select
                        id="vav_voice_select"
                        value={selectedVoice}
                        onChange={(e) => handleVoiceChange(e.target.value)}
                        placeholder="Choose a voice"
                      >
                        <option value="Linda">Linda</option>
                        <option value="Katie">Katie</option>
                        <option value="Savanah">Savanah</option>
                      </Select>
                    </FormControl>
                  </Box>
                </Flex>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
        <Modal onClose={onClose} isOpen={isOpen} size="lg">
          <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>Edit AI Settings</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody color="#B53D37" fontWeight="bold" minHeight="150px">
                        We highly recommend using the AI setup assistant to update your settings. Would you like to
                        continue?
                    </ModalBody>
                    <ModalFooter mr={4}>
                        <Button variant="ghost" onClick={onClose} mr={2}>Cancel</Button>
                        <Button
                            onClick={() => {
                                onClose()
                                navigate(`/settings/customize-ai/edit?bid=${bid}`);
                            }} minWidth="80px">Yes</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    )
};

export default CustomizeAI;
